import { Button, VbzInputText } from '@smiles/voebiz-ui-kit';
import { cpf } from 'cpf-cnpj-validator';
import dayjs, { Dayjs } from 'dayjs';
import React, { ChangeEvent, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { cpfMask } from '../../utils/maskCpf';
import CalendarMui from '../CalendarMui';

interface Props {
  handleIncludePersonClick(): void;
  handleBackButtonClick(): void;
  name: string;
  cpfValue: string;
  birthday: string;
  email: string;
  setName: React.Dispatch<React.SetStateAction<string>>;
  setCpfValue: React.Dispatch<React.SetStateAction<string>>;
  setBirthday: React.Dispatch<React.SetStateAction<Dayjs | null | undefined>>;
  setEmail: React.Dispatch<React.SetStateAction<string>>;
}

const IncludeBeneficiaryForm: React.FC<Props> = ({
  handleIncludePersonClick,
  handleBackButtonClick,
  name,
  cpfValue,
  birthday,
  email,
  setName,
  setCpfValue,
  setBirthday,
  setEmail,
}) => {
  const { t } = useTranslation(['includeTeam', 'summary', 'modalInclude']);

  const [error, setError] = useState(false);
  const [cpfError, setCpfError] = useState(false);
  const [isEmailValid, setIsEmailValid] = useState(true);
  const isButtonDisabled =
    !name || !cpfValue || !isEmailValid || error || cpfError || !email || birthday === 'Invalid Date';
  const validateName = (value: string) => {
    const word = value.trim().split(' ');
    if (word.length < 2) {
      setError(true);
    }
  };

  const handleNameInputChange = (event: ChangeEvent<HTMLInputElement>) => {
    const inputValue = event.target.value;
    setName(inputValue);
    setError(false);
    validateName(inputValue);
  };

  const validateEmail = (value: string) => {
    const emailRegex = /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/;
    setIsEmailValid(emailRegex.test(value));
  };

  const handleEmailChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { value } = event.target;
    validateEmail(value);
    setEmail(value);
  };

  const validateCpfFormat = (e: ChangeEvent<HTMLInputElement>) => {
    const validated = cpf.isValid(e.target.value);
    const doc = e.target.value.replace(/\s/g, '');
    setCpfValue(doc);
    setCpfError(!validated);
  };

  const handleKeyPressNumber = (e: React.KeyboardEvent) => {
    if (!(e.key >= '0' && e.key <= '9')) {
      e.preventDefault();
    }
  };

  return (
    <div className="include-one-form" data-testid="test-form">
      <VbzInputText
        value={name}
        onChange={handleNameInputChange}
        placeholder={t('modalInclude:name_placeholder')}
        errorMessage="Informe pelo menos 2 palavras."
        forceError={error}
        textLabel="Nome completo"
      />
      <VbzInputText
        alt="beneficiario-cpf"
        placeholder={t('modalInclude:cpf_placeholder')}
        textLabel="CPF"
        inputMode="numeric"
        value={cpfMask(cpfValue)}
        forceError={cpfError}
        onKeyPress={handleKeyPressNumber}
        errorMessage="Informe um CPF válido."
        onChange={(e) => {
          validateCpfFormat(e);
        }}
        maxLength={14}
      />
      <VbzInputText
        value={email}
        onChange={handleEmailChange}
        placeholder={t('modalInclude:email_placeholder')}
        errorMessage="Informe um e-mail válido."
        forceError={!isEmailValid}
        textLabel="E-mail"
      />
      <div className="calendar-summary">
        <p className="include-label">{t('summary:birthday_member')}</p>
        <CalendarMui
          data-testid="birthday"
          value={dayjs(birthday)}
          maxDate={dayjs()}
          openTo="year"
          views={['year', 'month', 'day']}
          onChange={(val) => setBirthday(val)}
          color={isButtonDisabled ? '#999999 !important' : '#000 !important'}
        />
      </div>
      <Button disabled={isButtonDisabled} onClick={handleIncludePersonClick}>
        {t('includeTeam:include_person')}
      </Button>
      <button className="underlined-back" type="button" onClick={handleBackButtonClick}>
        {t('includeTeam:go_back')}
      </button>
    </div>
  );
};

export default IncludeBeneficiaryForm;
